import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditClientData {
  // Pre-filled values when opening the client form for editing.

  name: string
  // Display name.

  gender: 'MALE' | 'FEMALE'
  // Sex/gender selection.

  phone: string | null
  // Phone number; null when absent.

  email: string | null
  // Email address; null when absent.

  roleIds: number[]
  // Ids of roles currently assigned to the client.

  startDatetime: string | null
  // Service start datetime (ISO string); null when absent.

  birthday: { day: number; month: number; year: number | null } | null
  // Broken-out birth date; null when absent; year null when unknown.
}

export const useAddClientFormStore = defineStore('addClientForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditClientData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditClientData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddClientFormStore, import.meta.hot))
}
